const Revenue: React.FC = () => {
  return (
    <>
      <p className='lg:flex hidden text-[13px]/[22px] self-end rounded-[64px] !text-[#05CD99] w-[66px] h-[27px] bg-[rgba(5,_205,_153,_0.20)] items-center justify-center'>+2.45%</p>
      <img src='/images/api-sdk-chart.svg' alt='api sdk chart' className='w-[67%]  pt-0.5' />
      <ul className='flex justify-between items-center'>
        <li className='text-[15px]/[25px] !text-white-dark font-medium'>05</li>
        <li className='text-[15px]/[25px] !text-white-dark font-medium'>10</li>
        <li className='text-[15px]/[25px] !text-white-dark font-medium'>15</li>
        <li className='text-[15px]/[25px] !text-white-dark font-medium'>20</li>
        <li className='text-[15px]/[25px] !text-white-dark font-medium'>25</li>
        <li className='text -[15px]/[25px] !text-white-dark font-medium'>30</li>
      </ul>
      <p className='pt-2 text-lg/8 font-medium text-black dark:text-white-other text-center pb-7'>Fees Generated </p>
    </>
  );
};

export default Revenue;
